import axios from "axios";
import React, { useEffect, useState } from "react";
import { server } from "../../server";
import { BsPencil } from "react-icons/bs";
import { RxCross1 } from "react-icons/rx";
import { toast } from "react-toastify";

const AllWithdraw = () => {
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [withdrawData, setWithdrawData] = useState();
  const [withdrawStatus,setWithdrawStatus] = useState('Processing');

  useEffect(() => {
    fetchWithdrawRequests();
  }, []);

  const fetchWithdrawRequests = () => {
    axios
      .get(`${server}/withdraw/get-all-withdraw-request`, {
        withCredentials: true,
      })
      .then((res) => {
        setData(res.data.withdraws);
      })
      .catch((error) => {
        console.log(error.response.data.message);
      });
  };

  const handleSubmit = async () => {
    await axios
      .put(`${server}/withdraw/update-withdraw-request/${withdrawData.id}`,{
        sellerId: withdrawData.shopId,
      },{withCredentials: true})
      .then((res) => {
        toast.success("Withdraw request updated successfully!");
        setData((currentData) => currentData.map((item) => (
          item._id === res.data.withdraw?._id ? { ...item, ...res.data.withdraw } : item
        )));
        setOpen(false);
      });
  };

  const rows = (data || []).map((item) => ({
    id: item._id,
    shopId: item.seller?._id || "N/A",
    name: item.seller?.name || "N/A",
    amount: `US$ ${item.amount}`,
    status: item.status,
    createdAt: item.createdAt ? item.createdAt.slice(0, 10) : "N/A",
  }));

  const openStatusModal = (row) => {
    setWithdrawData(row);
    setWithdrawStatus(row.status || "Processing");
    setOpen(true);
  };

  return (
    <div className="admin-withdraw-requests">
      <section className="admin-dashboard-orders__section admin-withdraw-requests__section">
        <h2 className="admin-dashboard-orders__title">Withdraw Requests</h2>
        <div className="admin-dashboard-orders__table-container admin-withdraw-requests__table-container">
          <table className="admin-dashboard-orders__table admin-withdraw-requests__table">
            <thead className="admin-dashboard-orders__thead">
              <tr>
                <th>Withdraw Id</th>
                <th>Shop Name</th>
                <th>Shop Id</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Request given at</th>
                <th>Update Status</th>
              </tr>
            </thead>
            <tbody className="admin-dashboard-orders__tbody">
              {rows.map((row) => (
                <tr key={row.id} className="admin-dashboard-orders__tr">
                  <td>{row.id}</td>
                  <td>{row.name}</td>
                  <td>{row.shopId}</td>
                  <td>{row.amount}</td>
                  <td>
                    <span className={`admin-withdraw-status admin-withdraw-status--${String(row.status || "unknown").toLowerCase()}`}>
                      {row.status || "N/A"}
                    </span>
                  </td>
                  <td>{row.createdAt}</td>
                  <td>
                    <button
                      type="button"
                      className="admin-withdraw-edit-button"
                      onClick={() => openStatusModal(row)}
                      disabled={row.status !== "Processing"}
                      aria-label={`Update withdraw request ${row.id}`}
                    >
                      <BsPencil size={18} aria-hidden="true" />
                      <span>Update</span>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
      {open && (
        <div className="admin-withdraw-modal-overlay">
          <div className="admin-withdraw-modal">
            <button type="button" className="admin-withdraw-modal-close" onClick={() => setOpen(false)} aria-label="Close withdraw status modal">
              <RxCross1 size={20} aria-hidden="true" />
            </button>
            <h2 className="admin-withdraw-modal-title">
              Update Withdraw status
            </h2>
            <label className="admin-withdraw-modal-field">
              <span>Status</span>
              <select
                value={withdrawStatus}
                onChange={(e) => setWithdrawStatus(e.target.value)}
              >
                <option value="Processing">Processing</option>
                <option value="Succeed">Succeed</option>
              </select>
            </label>
            <button
              type="submit"
              className="admin-withdraw-modal-submit"
              onClick={handleSubmit}
            >
              Update
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AllWithdraw;
